import HeatMapWidgetView from './HeatMapWidgetView.vue';

export const type = 'heatMap';
export const view = HeatMapWidgetView;

export function builder() {
  return {
    type,
    left: 0,
    top: 0,
    rotate: 0,
    height: 300,
    width: 350,
    background: '#FFFFFF',
  };
}
